import * as DocumentEvents from './events-definition'

export { DocumentEvents }
